import { ReactNode } from 'react';

import { Box, Stack, Text } from '@mantine/core';

import env from '@config/env';
import logo from '@assets/images/logo.png';
import classes from './GuestLayout.module.css';

interface GuestLayoutProps {
  size?: number;
  children: ReactNode;
}

export default function GuestLayout({
  size = 600,
  children,
}: GuestLayoutProps) {
  return (
    <Stack align="center" justify="space-between" py="xl" px="md" mih="100vh">
      <Stack align="center" mt="xl" w="100%" style={{ minWidth: 0 }}>
        <img src={logo} className={classes.logo} alt="Prodotti Gianni" />
        <Box maw={size} w="100%" mx="auto" style={{ minWidth: 0 }}>
          {children}
        </Box>
      </Stack>
      <Text size="xs" c="dimmed">
        v{env.APP_VERSION}
      </Text>
    </Stack>
  );
}
